import Svg, { Defs, ClipPath, Rect, Path, G } from "react-native-svg";

const CheckCircleOutlineIcon = ({ isSelected, fill, ...props }) => (
    <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <G clip-path="url(#clip0_7650_2139)">
            <Path d="M13.8243 6.31602L8.33268 11.8077L5.34102 8.82435L4.16602 9.99935L8.33268 14.166L14.9993 7.49935L13.8243 6.31602ZM9.99935 1.66602C5.39935 1.66602 1.66602 5.39935 1.66602 9.99935C1.66602 14.5993 5.39935 18.3327 9.99935 18.3327C14.5993 18.3327 18.3327 14.5993 18.3327 9.99935C18.3327 5.39935 14.5993 1.66602 9.99935 1.66602ZM9.99935 16.666C6.31602 16.666 3.33268 13.6827 3.33268 9.99935C3.33268 6.31602 6.31602 3.33268 9.99935 3.33268C13.6827 3.33268 16.666 6.31602 16.666 9.99935C16.666 13.6827 13.6827 16.666 9.99935 16.666Z" fill={fill ?? "#4EB826"} />
        </G>
        <Defs>
            <ClipPath id="clip0_7650_2139">
                <Rect width="20" height="20" fill="white" />
            </ClipPath>
        </Defs>
    </Svg>
);
export default CheckCircleOutlineIcon;
